import React from 'react';
import { usePaginationFragment } from 'react-relay/hooks';

import { Grid } from '@material-ui/core';
import { graphql } from 'babel-plugin-relay/macro';
import FilterListWrapper from 'core/FiltersDialog/components/FiltersListWrapper';
import { useDialogContext, useFiltersContext } from 'core/FiltersDialog/FiltersDialogContext';
import { compact, get, map } from 'lodash';

import { Chip, ChipLoader, InfiniteScroll } from 'components/v2';

import FilterEmptyState from '../FilterEmptySate';

import { FilterFollowupList_Query$key } from './__generated__/FilterFollowupList_Query.graphql';

interface FilterFollowupListProps {
  fragmentRef: FilterFollowupList_Query$key;
  type: string;
}

const FilterFollowupList: React.FC<FilterFollowupListProps> = ({ fragmentRef, type }) => {
  const { filters, updater } = useFiltersContext();
  const { toggleLockFilters } = useDialogContext();

  const {
    data: { followupConnection },
    loadNext,
    isLoadingNext,
    hasNext,
  } = usePaginationFragment<any, FilterFollowupList_Query$key>(
    graphql`
      fragment FilterFollowupList_Query on Query
        @argumentDefinitions(cursor: { type: "String" }, count: { type: "Int", defaultValue: 25 })
        @refetchable(queryName: "FilterFollowupList_refetchable") {
        followupConnection(first: $count, after: $cursor, filter: $filter, sort: TITLE_ASC)
          @connection(key: "FilterFollowupList_followupConnection") {
          edges {
            node {
              _id
              title
            }
          }
        }
      }
    `,
    fragmentRef,
  );

  const followups = compact(map(get(followupConnection, 'edges'), 'node'));

  const handleSelectItem = (item: any) => {
    updater(type)(item._id);
    toggleLockFilters(false);
  };

  const isSelected = (id: string) =>
    (filters[type].includes('all') && !filters[type].includes(id)) ||
    (filters[type].includes('all') && filters[type].lenth === 1) ||
    (!filters[type].includes('all') && filters[type].includes(id));

  return (
    <FilterListWrapper>
      <InfiniteScroll hasNext={hasNext} isLoadingNext={isLoadingNext} loadNext={() => loadNext(25)}>
        <Grid container spacing={8}>
          {get(followups, 'length', 0) === 0 ? (
            <FilterEmptyState />
          ) : (
            followups
              .filter(({ title }) => title !== '' && title !== undefined)
              .map((item: any) => (
                <Grid item key={item._id}>
                  <Chip
                    color="supportPowder"
                    onClick={() => handleSelectItem(item)}
                    label={item.title}
                    selected={isSelected(item._id)}
                  />
                </Grid>
              ))
          )}
        </Grid>
      </InfiniteScroll>
      {isLoadingNext && <ChipLoader />}
    </FilterListWrapper>
  );
};

export default (props: any) => (
  <React.Suspense fallback={null}>
    <FilterFollowupList {...props} />
  </React.Suspense>
);
